import { clean, num, titleCase } from './quinn';

export interface Floorplan {
  floorplan_id?: string;
  floorplan_name?: string;
  floorplan_image_url?: string;
  floorplan_beds_min?: string;
  floorplan_baths_min?: string;
  floorplan_sqft_min?: string;
  floorplan_sqft_max?: string;
  floorplan_price_min?: string;
  floorplan_available_units?: string;
}

export interface PlanCard {
  key: string;
  name: string;
  img: string | null;
  beds: number | null;
  baths: number | null;
  sqft: number | null;
  sqftMax: number | null;
  price: number | null;
  avail: number;
}

export function toPlanCards(plans: Floorplan[]): PlanCard[] {
  return plans
    .map((f, i) => ({
      key: f.floorplan_id || String(i),
      name: titleCase(f.floorplan_name),
      img: clean(f.floorplan_image_url),
      beds: num(f.floorplan_beds_min),
      baths: num(f.floorplan_baths_min),
      sqft: num(f.floorplan_sqft_min),
      sqftMax: num(f.floorplan_sqft_max),
      price: num(clean(f.floorplan_price_min)),
      avail: num(f.floorplan_available_units) || 0,
    }))
    .sort((a, b) => (a.beds ?? 99) - (b.beds ?? 99) || (a.sqft ?? 0) - (b.sqft ?? 0));
}
